var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFmsCollision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib2foszwta"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15413",
    transform: "translate(979 2738)",
    style: {
      fill: "#ff2e2e",
      opacity: 0.158
    },
    d: "M0 0h180v180H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "51tue9xu8b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15410",
    style: {
      fill: "none"
    },
    d: "M0 0h52.68v83.814H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 706",
    transform: "translate(-979 -2738)",
    style: {
      clipPath: "url(#ib2foszwta)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 704",
    transform: "translate(1001.388 2812.185)",
    style: {
      clipPath: "url(#51tue9xu8b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59649",
    d: "M61.885 85.506H10.036a1.843 1.843 0 0 1-1.843-1.843V49.111a1.843 1.843 0 0 1 1.843-1.843h51.847a1.843 1.843 0 0 1 1.843 1.843v34.554a1.843 1.843 0 0 1-1.843 1.843M10.036 48.144a.965.965 0 0 0-.964.966v34.555a.965.965 0 0 0 .964.964h51.847a.965.965 0 0 0 .964-.964V49.111a.964.964 0 0 0-.964-.964z",
    transform: "translate(-23.155 -44.11)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59650",
    d: "M61.885 85.506H10.036a1.843 1.843 0 0 1-1.843-1.843V49.111a1.843 1.843 0 0 1 1.843-1.843h51.847a1.843 1.843 0 0 1 1.843 1.843v34.554a1.843 1.843 0 0 1-1.843 1.843M10.036 48.144a.965.965 0 0 0-.964.966v34.555a.965.965 0 0 0 .964.964h51.847a.965.965 0 0 0 .964-.964V49.111a.964.964 0 0 0-.964-.964z",
    transform: "translate(-23.155 -44.11)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59651",
    d: "M38.186 59.116H23.393a1.668 1.668 0 0 1-1.665-1.665V47.268h18.123V57.45a1.668 1.668 0 0 1-1.665 1.665M22.6 48.145v9.305a.789.789 0 0 0 .79.788h14.793a.79.79 0 0 0 .79-.788v-9.306z",
    transform: "translate(-17.668 -44.11)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59652",
    d: "M38.186 59.116H23.393a1.668 1.668 0 0 1-1.665-1.665V47.268h18.123V57.45a1.668 1.668 0 0 1-1.665 1.665M22.6 48.145v9.305a.789.789 0 0 0 .79.788h14.793a.79.79 0 0 0 .79-.788v-9.306z",
    transform: "translate(-17.668 -44.11)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59653",
    d: "M77.119 80.106H.94a.438.438 0 0 1-.44-.438v-3.975a1.843 1.843 0 0 1 1.846-1.843h73.372a1.843 1.843 0 0 1 1.843 1.843v3.976a.438.438 0 0 1-.438.437M1.385 79.23h75.3v-3.537a.966.966 0 0 0-.964-.964H2.346a.964.964 0 0 0-.964.964z",
    transform: "translate(-26.273 -33.333)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59654",
    d: "M77.119 80.106H.94a.438.438 0 0 1-.44-.438v-3.975a1.843 1.843 0 0 1 1.846-1.843h73.372a1.843 1.843 0 0 1 1.843 1.843v3.976a.438.438 0 0 1-.438.437M1.385 79.23h75.3v-3.537a.966.966 0 0 0-.964-.964H2.346a.964.964 0 0 0-.964.964z",
    transform: "translate(-26.273 -33.333)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15409",
    transform: "translate(-18.11 46.455)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h61.738v4.583H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59655",
    d: "M29.786 103.894c-3.615 0-6.555-2.332-6.555-5.2h.876c0 2.385 2.548 4.323 5.678 4.323s5.679-1.939 5.679-4.323h.877c0 2.867-2.94 5.2-6.556 5.2",
    transform: "translate(-17.058 -23.26)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59656",
    d: "M29.786 103.894c-3.615 0-6.555-2.332-6.555-5.2h.876c0 2.385 2.548 4.323 5.678 4.323s5.679-1.939 5.679-4.323h.877c0 2.867-2.94 5.2-6.556 5.2",
    transform: "translate(-17.058 -23.26)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59657",
    d: "M50.617 103.917a5.23 5.23 0 0 1-5.224-5.223h.876a4.348 4.348 0 0 0 8.7 0h.876a5.223 5.223 0 0 1-5.224 5.223",
    transform: "translate(-8.073 -23.26)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59658",
    d: "M50.617 103.917a5.23 5.23 0 0 1-5.224-5.223h.876a4.348 4.348 0 0 0 8.7 0h.876a5.223 5.223 0 0 1-5.224 5.223",
    transform: "translate(-8.073 -23.26)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59659",
    d: "M77.559 94.913H63.611a10.082 10.082 0 0 1-7.369-3.05l-.082-.084a4.2 4.2 0 0 0-3.079-1.4H.5v-5.435h77.059zM1.381 89.5H53.09a5.071 5.071 0 0 1 3.723 1.689l.07.077a9.2 9.2 0 0 0 6.728 2.774h13.071v-8.223H1.381z",
    transform: "translate(-26.274 -28.835)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59660",
    d: "M77.559 94.913H63.611a10.082 10.082 0 0 1-7.369-3.05l-.082-.084a4.2 4.2 0 0 0-3.079-1.4H.5v-5.435h77.059zM1.381 89.5H53.09a5.071 5.071 0 0 1 3.723 1.689l.07.077a9.2 9.2 0 0 0 6.728 2.774h13.071v-8.223H1.381z",
    transform: "translate(-26.274 -28.835)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59661",
    d: "M45.035 88.832a1.189 1.189 0 1 1-1.195-1.182h.006a1.185 1.185 0 0 1 1.188 1.182",
    transform: "translate(-9.182 -27.738)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59662",
    d: "M47.832 88.832a1.189 1.189 0 1 1-1.195-1.182h.006a1.184 1.184 0 0 1 1.189 1.182",
    transform: "translate(-8.048 -27.738)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59663",
    d: "M50.629 88.832a1.189 1.189 0 1 1-1.195-1.182h.006a1.185 1.185 0 0 1 1.188 1.182",
    transform: "translate(-6.914 -27.738)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59664",
    d: "M53.426 88.832a1.189 1.189 0 1 1-1.195-1.182h.006a1.185 1.185 0 0 1 1.189 1.182",
    transform: "translate(-5.78 -27.738)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59665",
    d: "M77.121 105.539H.94a.438.438 0 0 1-.44-.439V82.951a1.844 1.844 0 0 1 1.844-1.843h73.374a1.843 1.843 0 0 1 1.843 1.843V105.1a.438.438 0 0 1-.438.438m-75.743-.876h75.3V82.951a.966.966 0 0 0-.964-.964H2.346a.966.966 0 0 0-.964.964z",
    transform: "translate(-26.273 -30.39)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59666",
    d: "M77.121 105.539H.94a.438.438 0 0 1-.44-.439V82.951a1.844 1.844 0 0 1 1.844-1.843h73.374a1.843 1.843 0 0 1 1.843 1.843V105.1a.438.438 0 0 1-.438.438m-75.743-.876h75.3V82.951a.966.966 0 0 0-.964-.964H2.346a.966.966 0 0 0-.964.964z",
    transform: "translate(-26.273 -30.39)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 705",
    transform: "translate(1083.926 2812.185)",
    style: {
      clipPath: "url(#51tue9xu8b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59667",
    d: "M139.943 85.506H88.094a1.843 1.843 0 0 1-1.843-1.843V49.111a1.843 1.843 0 0 1 1.843-1.843h51.848a1.843 1.843 0 0 1 1.843 1.843v34.554a1.843 1.843 0 0 1-1.843 1.843M88.094 48.144a.965.965 0 0 0-.964.966v34.555a.965.965 0 0 0 .964.964h51.848a.965.965 0 0 0 .964-.964V49.111a.964.964 0 0 0-.964-.964z",
    transform: "translate(-74.046 -44.11)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59668",
    d: "M139.943 85.506H88.094a1.843 1.843 0 0 1-1.843-1.843V49.111a1.843 1.843 0 0 1 1.843-1.843h51.848a1.843 1.843 0 0 1 1.843 1.843v34.554a1.843 1.843 0 0 1-1.843 1.843M88.094 48.144a.965.965 0 0 0-.964.966v34.555a.965.965 0 0 0 .964.964h51.848a.965.965 0 0 0 .964-.964V49.111a.964.964 0 0 0-.964-.964z",
    transform: "translate(-74.046 -44.11)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59669",
    d: "M116.244 59.116h-14.793a1.668 1.668 0 0 1-1.665-1.665V47.268h18.123V57.45a1.668 1.668 0 0 1-1.665 1.665m-15.584-10.97v9.305a.789.789 0 0 0 .79.788h14.791a.79.79 0 0 0 .79-.788v-9.306z",
    transform: "translate(-68.559 -44.11)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59670",
    d: "M116.244 59.116h-14.793a1.668 1.668 0 0 1-1.665-1.665V47.268h18.123V57.45a1.668 1.668 0 0 1-1.665 1.665m-15.584-10.97v9.305a.789.789 0 0 0 .79.788h14.791a.79.79 0 0 0 .79-.788v-9.306z",
    transform: "translate(-68.559 -44.11)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59671",
    d: "M155.176 80.106H79a.438.438 0 0 1-.437-.437v-3.976A1.842 1.842 0 0 1 80.4 73.85h73.372a1.844 1.844 0 0 1 1.844 1.843v3.976a.438.438 0 0 1-.439.437m-75.734-.876h75.3v-3.537a.967.967 0 0 0-.966-.964H80.4a.964.964 0 0 0-.963.964z",
    transform: "translate(-77.164 -33.333)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59672",
    d: "M155.176 80.106H79a.438.438 0 0 1-.437-.437v-3.976A1.842 1.842 0 0 1 80.4 73.85h73.372a1.844 1.844 0 0 1 1.844 1.843v3.976a.438.438 0 0 1-.439.437m-75.734-.876h75.3v-3.537a.967.967 0 0 0-.966-.964H80.4a.964.964 0 0 0-.963.964z",
    transform: "translate(-77.164 -33.333)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15411",
    transform: "translate(9.055 46.455)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h61.738v4.583H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59673",
    d: "M86.286 103.917a5.231 5.231 0 0 1-5.224-5.223h.877a4.348 4.348 0 0 0 8.7 0h.876a5.228 5.228 0 0 1-5.225 5.223",
    transform: "translate(-76.15 -23.26)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59674",
    d: "M86.286 103.917a5.231 5.231 0 0 1-5.224-5.223h.877a4.348 4.348 0 0 0 8.7 0h.876a5.228 5.228 0 0 1-5.225 5.223",
    transform: "translate(-76.15 -23.26)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59675",
    d: "M107.843 103.894c-3.615 0-6.555-2.332-6.555-5.2h.877c0 2.385 2.547 4.323 5.677 4.323s5.681-1.939 5.681-4.323h.876c0 2.867-2.94 5.2-6.556 5.2",
    transform: "translate(-67.95 -23.26)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59676",
    d: "M107.843 103.894c-3.615 0-6.555-2.332-6.555-5.2h.877c0 2.385 2.547 4.323 5.677 4.323s5.681-1.939 5.681-4.323h.876c0 2.867-2.94 5.2-6.556 5.2",
    transform: "translate(-67.95 -23.26)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59677",
    d: "M155.617 94.913h-13.948a10.082 10.082 0 0 1-7.369-3.05l-.083-.084a4.19 4.19 0 0 0-3.078-1.4H78.557v-5.435h77.06zM79.438 89.5h51.71a5.066 5.066 0 0 1 3.722 1.689l.07.077a9.2 9.2 0 0 0 6.729 2.774h13.071v-8.223h-75.3z",
    transform: "translate(-77.166 -28.835)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59678",
    d: "M155.617 94.913h-13.948a10.082 10.082 0 0 1-7.369-3.05l-.083-.084a4.19 4.19 0 0 0-3.078-1.4H78.557v-5.435h77.06zM79.438 89.5h51.71a5.066 5.066 0 0 1 3.722 1.689l.07.077a9.2 9.2 0 0 0 6.729 2.774h13.071v-8.223h-75.3z",
    transform: "translate(-77.166 -28.835)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59679",
    d: "M155.178 105.539H79a.438.438 0 0 1-.438-.437V82.951a1.844 1.844 0 0 1 1.838-1.843h73.372a1.843 1.843 0 0 1 1.843 1.843V105.1a.438.438 0 0 1-.439.438m-75.743-.876h75.3V82.951a.966.966 0 0 0-.964-.964H80.4a.966.966 0 0 0-.964.964z",
    transform: "translate(-77.165 -30.39)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59680",
    d: "M155.178 105.539H79a.438.438 0 0 1-.438-.437V82.951a1.844 1.844 0 0 1 1.838-1.843h73.372a1.843 1.843 0 0 1 1.843 1.843V105.1a.438.438 0 0 1-.439.438m-75.743-.876h75.3V82.951a.966.966 0 0 0-.964-.964H80.4a.966.966 0 0 0-.964.964z",
    transform: "translate(-77.165 -30.39)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 711"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59681",
    d: "M70.825 2.948 51.243 36.866a3.9 3.9 0 0 0 3.375 5.845h39.163a3.9 3.9 0 0 0 3.375-5.845L77.574 2.948a3.9 3.9 0 0 0-6.749 0z",
    transform: "translate(994.797 2760)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#4cbbb8",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 114",
    transform: "translate(1068.997 2774.483)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0v13.027"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59682",
    d: "M69.342 24.589a1.831 1.831 0 1 1-1.832-1.832 1.832 1.832 0 0 1 1.832 1.832",
    transform: "translate(1001.487 2769.727)",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFmsCollision);
export default __webpack_public_path__ + "static/media/ico_fms_collision.23ba156f0b4cb8093f8eacf4f1ab5a51.svg";
export { ForwardRef as ReactComponent };